import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { InputComponent } from './input/input.component';


@Component({
    selector: 'odq-input-group',
    templateUrl: './input-group.component.html',
    styleUrls: ['./input-group.component.scss'],
    standalone: false
})
export class InputGroupComponent implements OnInit {

  private _collapseField: boolean;
  get collapseField(): boolean {
    return this._collapseField == undefined ? true : this._collapseField;
  }

  @Input() Gutter = 8;

  @Input()
  set collapseField(value: boolean) {
    this._collapseField = coerceBooleanProperty(value);
  }

  @ContentChildren(InputComponent) contents: QueryList<InputComponent>;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit() {

  }

  calcItemWidth(index: number) {
    const item = this.contents.find((c, i) => {
      return i == index;
    });

    // flex: 0 0 100px;    /* don't grow, don't shrink, stay fixed at 100px */
    return this.sanitizer.bypassSecurityTrustStyle('0 1 ' + item.colPercentSize + '%');
    // return this.sanitizer.bypassSecurityTrustStyle("0 1 calc(" + item.colPercentSize + "% - 0px");
  }

  calcItemMargin(index: number) {
    const previousContent = this.contents.toArray().slice(0, index + 1);
    const totalItemsWidth = previousContent.reduce(function (total, x) { return total += x.colPercentSize; }, 0);
    const isLastInRow = totalItemsWidth % 100 == 0;

    if (!!this.contents && (this.contents.length - 1 > index) && !isLastInRow) {
      return this.Gutter;
    } else {
      return 0;
    }
  }

  hasSeparator(i: number): boolean {
    return this.collapseField; // && this.separatorIndexArray.includes(i);
  }

  trackContent(index, content) {
    return content;
  }

  // private detectWrap() {
  //   var wrappedItems: Array<number> = [];
  //   var prevItem: any = {};
  //   var currItem: any = {};

  //   var items = document.getElementsByClassName("input-group-item");

  //   for (var i = 0; i < items.length; i++) {
  //     currItem = items[i].getBoundingClientRect();
  //     if (prevItem && prevItem.top < currItem.top) {
  //       wrappedItems.push(i);
  //     }
  //     prevItem = currItem;
  //   };

  //   return wrappedItems;
  // }
}
